__turbopack_context__.v({
  "header": "styles-module__ZWIiSa__header",
  "headerImg": "styles-module__ZWIiSa__headerImg",
  "text": "styles-module__ZWIiSa__text",
  "title": "styles-module__ZWIiSa__title",
  "wrapper": "styles-module__ZWIiSa__wrapper",
});
